module.exports = __webpack_public_path__ + "static/media/hand_luggage_b.012765f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/hand_luggage_b.png
// module id = 1409
// module chunks = 0